export function buildAvatarUrl(pictureUrl: string, size: number) {
  return pictureUrl
    ? `${pictureUrl}?d=${size}x${size}`
    : null;
}